module.exports = __webpack_public_path__ + "static/media/slide_3x2.2d07bdee.png";